interface ExportResult {
  success: boolean;
}

interface ExportPlugin {
  label: string;
  description: string;
  export: (productId: string) => Promise<ExportResult>;
}

const professionalPlugin: ExportPlugin = {
  label: "Professional (High-Res)",
  description: "Server-side rendering at 2480x2480px @ 300 DPI for print",

  export: async (productId: string): Promise<ExportResult> => {
    try {
      // Generate CLI command
      const command = `lymaprint export ${productId}`;

      // Copy to clipboard
      await navigator.clipboard.writeText(command);

      // Show success message with command
      alert(
        `Command copied to clipboard!\n\n` +
          `Run this command locally to export the PDF:\n\n` +
          `${command}\n\n` +
          `Make sure you have:\n` +
          `1. Installed CLI dependencies: cd cli && npm install\n` +
          `2. Logged in: cd cli && node bin/lymaprint.js auth login`,
      );

      return { success: true };
    } catch (error) {
      console.error("Failed to copy command:", error);
      throw new Error("Failed to copy export command to clipboard");
    }
  },
};

export default professionalPlugin;
